import { Component, OnInit } from '@angular/core';
import { filter, take } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AppUpdateToastComponent } from './components/app-update-toast/app-update-toast.component';
import { DeploymentUpdateService } from './services/deployment-update.service';
import { Principal } from './shared/auth/principal.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    title = 'data-science';

    constructor(
        private readonly deploymentUpdateService: DeploymentUpdateService,
        private readonly toastr: ToastrService,
        private readonly principal: Principal,
    ) {}

    ngOnInit(): void {
        this.deploymentUpdateService.start();
        this.deploymentUpdateService.updateAvailable$
            .pipe(filter(Boolean), take(1))
            .subscribe(() => this.showUpdateNotification());
    }

    private showUpdateNotification(): void {
        const toast = this.toastr.info('', '', {
            closeButton: true,
            disableTimeOut: true,
            progressBar: false,
            tapToDismiss: false,
            toastComponent: AppUpdateToastComponent,
        });

        toast.onAction
            .pipe(take(1))
            .subscribe(() => this.deploymentUpdateService.reload());
    }
}
